"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "كل الدورات التعليمية",
    "className": "اسم ورشة العمل",
    "continue": "الاستمرار",
    "courseChapter": "الفصل",
    "courseEvaluate": "التقييم",
    "courseHours": "الساعات المعتمدة",
    "courseInfo": "التفاصيل",
    "courseNote": "ملاحظات",
    "coursesCategory": "فئات الدورات التعليمية",
    "electiveCourses": "دورة تعليمية اختيارية",
    "pages": "الصفحة",
    "relatedCourses": "دورات تعليمية ذات صلة",
    "requiredCourses": "المحاضرة",
    "searchTips": "يرجى إدخال اسم الدورة التعليمية",
    "studentsNum": "عدد الجمهور",
    "teachersDesc": "المدرس",
    "newCourse": "أحدث الدورات"
  },
  "footer_zlb": {
    "aboutUs": "من نحن",
    "downLoad": "تنزيل التطبيق",
    "qr": "رمز الاستجابة السريع (QR)"
  },
  "global_zlb": {
    "am": "صباحًا",
    "night": "مساءً",
    "pm": "مساءً"
  },
  "header_zlb": {
    "accoutPw": "كلمة مرور الحساب",
    "curDis": "جارية",
    "curUser": "المستخدم الحالي",
    "edit": "تحديث",
    "helpCenter": "مركز المساعدة",
    "hisDis": "السجل",
    "index": "الصفحة الرئيسية",
    "joinStore": "إضافة إلى المفضلات",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "رسالة",
    "setIndex": "تعيين بمثابة الصفحة الرئيسية",
    "userImg": "صورة الملف الشخصي"
  },
  "index_zlb": {
    "discuss": "ورشة العمل",
    "find": "اكتشف",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "أنا"
  },
  "info_zlb": {
    "admin": "المشرف",
    "hasAgenda": "لقد انضممت إلى الجدول الزمني بالفعل.",
    "noDown": "لا توجد مرفقات للتنزيل!",
    "pleaseInp": "يرجى الدخول",
    "submit": "تم الإرسال بنجاح!",
    "withinTime": "المهمة لم تبدأ بعد",
    "noSubmitWork": "لم يتم إرسال الواجب"
  },
  "login_zlb": {
    "accountLogin": "تسجيل الدخول",
    "accountNotEmpty": "يجب كتابة الحساب",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "إلغاء",
    "captchaNotEmpty": "يجب كتابة رمز التحقق",
    "captchaTips": "رمز التحقق غير صحيح",
    "changeEmail": "تحديث البريد الإلكتروني",
    "changeEmailSuccess": "تم تحديث عنوان البريد الإلكتروني بنجاح.",
    "changeEmailSuccessTips": "قمت بتحديث عنوان البريد الإلكتروني بنجاح.",
    "Confirm": "تأكيد",
    "currentEmail": "عنوان البريد الإلكتروني الحالي",
    "emailCaptcha": "رمز التحقق من البريد الإلكتروني",
    "emailCaptchaEmpty": "رمز التحقق من البريد الإلكتروني",
    "encryEmail": "عنوان البريد الإلكتروني الإضافي",
    "error": "خطأ في رمز التحقق",
    "forget": "نسيت كلمة المرور",
    "formerEamil": "عنوان البريد الإلكتروني الأصلي",
    "incorrectTips": "خطأ بإدخال اسم المستخدم أو كلمة المرور",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "بريد إلكتروني جديد",
    "newEmailBinded": "عنوان البريد الإلكتروني الجديد مرتبط بحساب المستخدم الخاص بك",
    "newEmailEmpty": "لا يمكن أن يكون البريد الإلكتروني الجديد فارغًا",
    "newEmailFomat": "صيغة البريد الإلكتروني الجديد غير صحيحة",
    "newEmailSupport": "لا يمكن أن يتطابق عنوان البريد الإلكتروني القديم والجديد",
    "prevStep": "الخطوة السابقة",
    "nextStep": "الخطوة التالية",
    "reset": "إعادة التعيين",
    "loginNow": "تسجيل الدخول الآن",
    "resetSuccess": "تم إعادة التعيين بنجاح",
    "resetSuccessTips": "لقد قمت بإعادة تعيين كلمة المرور بنجاح. يرجى الذهاب لتسجيل الدخول",
    "msgCaptcha": "رمز المصادقة عبر رسالة SMS",
    "getCaptcha": "الحصول على رمز المصادقة",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "loginFail": "فشل تسجيل الدخول، يرجى إعادة المحاولة!",
    "failTips": "فشل التحقق",
    "inputUserName": "اسم المستخدم",
    "goHome": "الذهاب إلى الصفحة الرئيسية",
    "passwordFormat": "يجب أن تكون كلمة المرور من 8-32 رقم وأن تحتوي على أرقام وحروف كبيرة وصغيرة.",
    "surePasswordEmpty": "تأكيد كلمة المرور لا يمكن أن يكون فارغًا",
    "confirmNot": "كلمة المرور وتأكيد كلمة المرور غير متطابقان",
    "changePasswordSuccess": "تم تحديث كلمة المرور بنجاح",
    "continueLogin": "تسجيل الدخول مجددًا",
    "orError": "اسم المستخدم أو كلمة المرور غير صحيح",
    "orgEmailEmpty": "البريد الإلكتروني الأصلي لا يمكن أن يكون فارغًا",
    "orgEmailFormat": "صيغة البريد الإلكتروني الأصلي غير صحيحة",
    "orgEmailNot": "عنوان البريد الإلكتروني الأصلي غير صحيح",
    "passWord": "كلمة المرور",
    "surePassword": "تأكيد كلمة المرور",
    "passwordBits": "يجب أن يكون طول كلمة المرور 6 حروف على الأقل",
    "passwordNotEmpty": "يجب ملء خانة كلمة المرور",
    "pWord": "كلمة المرور",
    "sign": "تسجيل الدخول",
    "uName": "الحساب",
    "userName": "اسم المستخدم",
    "validate": "رمز المصادقة",
    "verification": "يرجى إكمال المصادقة بالأسفل",
    "appdownload": "تنزيل التطبيق",
    "scancode": "امسح رمز الاستجابة السريع للتنزيل",
    "poor": "ضعيف",
    "middle": "متوسط",
    "strong": "قوي"
  },
  "login": {
    "logout": "تم تسجيل الخروج بنجاح",
    "resetLoginTips": "قمت بتغيير كلمة المرور بنجاح، ستحتاج إلى تسجيل الدخول مجددًا، وتسجيل الخروج تلقائيًا بعد 3 ثواني",
    "sure": "تأكيد",
    "cancel": "إلغاء",
    "captchaNotEmpty": "يجب كتابة رمز التحقق",
    "accountNotEmpty": "يجب كتابة الحساب",
    "passwordNotEmpty": "يجب ملء خانة كلمة المرور",
    "inputCaptcha": "رمز المصادقة",
    "getCaptcha": "الحصول على رمز المصادقة",
    "inputOrigPassword": "يرجى إدخال كلمة المرور الأصلية",
    "inputNewPassowrd": "يرجى إدخال كلمة المرور جديدة",
    "confimPassword": "تأكيد كلمة المرور",
    "changePassword": "تغيير كلمة المرور",
    "nextStep": "الخطوة التالية",
    "resetPassword": "إعادة تعيين كلمة المرور",
    "resetDone": "نجحت إعادة تعيين كلمة المرور",
    "msgCaptcha": "رمز التحقق من البريد الإلكتروني"
  },
  "look_zlb": {
    "aboutLecturer": "دورات تعليمية ذات صلة",
    "benginLearn": "ابدأ التعلّم",
    "chapter": "الفصل",
    "delete": "حذف",
    "details": "التفاصيل",
    "download": "تنزيل",
    "dynamic": "الأخبار",
    "evaluation": "تقييم",
    "hotDyc": "الأكثر رواجًا",
    "lecture": "فتح دورة تعليمية",
    "lecturer": "المدرس",
    "lectureTest": "فئات الدورات التعليمية",
    "look": "اكتشف",
    "lookAll": "عرض الكل",
    "note": "ملاحظات",
    "score": "الدرجة"
  },
  "myMessage_zlb": {
    "passwordError": "خطأ بإدخال كلمة المرور الأصلية",
    "aboutUs": "من نحن",
    "allcourse": "كل الدورات التعليمية",
    "atypism": "كلمتا المرور لا تتطابقان",
    "birth": "تاريخ الميلاد",
    "cancel": "إلغاء",
    "carryOut": "اكتمل",
    "changePassword": "تغيير كلمة المرور",
    "chineseName": "الاسم الصيني",
    "chineseNamePlaceholder": "يرجى إدخال الاسم الصيني",
    "code": "رمز التحقق",
    "codeError": "خطأ في رمز التحقق",
    "comment": "التعليق",
    "complete": "اكتمل",
    "completeUserInfo": "يرجى اكمال المعلومات الشخصية",
    "confirm": "تأكيد كلمة المرور",
    "continueStudy": "الاستمرار",
    "country": "البلد",
    "countryName": "الاسم",
    "countryNamePlaceholder": "يرجى إدخال اسمك",
    "countryPlaceholder": "يرجى اختيار بلد",
    "courseLearned": "اكتمل",
    "delete": "حذف",
    "documentType": "نوع وثيقة الهوية",
    "downloaded": "تم التنزيل",
    "downloading": "جاري التنزيل",
    "eduLevel": "مستوى التعليم",
    "eduLevelPlaceholder": "يرجى اختيار مستوى التعليم",
    "email": "البريد الإلكتروني",
    "emailCode": "رمز التحقق من البريد الإلكتروني",
    "gender": "النوع",
    "genderPlaceholder": "يرجى اختيار نوع",
    "getCode": "الحصول على رمز مصادقة البريد الإلكتروني",
    "hasSent": "تم الإرسال",
    "helpCenter": "مركز المساعدة",
    "hour": "ساعة",
    "improveInformation": "يرجى اكمال المعلومات الشخصية",
    "joinClasses": "عدد المشاركين في الدورة التعليمية",
    "joinDis": "عدد المشاركين في ورش العمل",
    "learned": "عدد من أنهوا الدورة التعليمية",
    "learning": "عدد من لم ينهوا الدورة التعليمية",
    "lecture": "الدورة التعليمية",
    "mailbox": "البريد الإلكتروني",
    "mailboxValidate": "فشلت مصادقة البريد الإلكتروني",
    "man": "ذكر",
    "management": "الإعدادات",
    "minutes": "× ساعة × دقيقة",
    "modify": "تحديث",
    "modifyEmail": "تحديث البريد الإلكتروني",
    "my": "أنا",
    "myCertificate": "شهاداتي",
    "mycourse": "دوراتي التعليمية",
    "myDownload": "تنزيلاتي",
    "myLecture": "دوراتي التعليمية",
    "myNotes": "ملاحظاتي",
    "newMail": "بريد إلكتروني جديد",
    "newPassword": "كلمة المرور الجديدة",
    "nextStep": "الخطوة التالية",
    "orError": "اسم المستخدم أو كلمة المرور غير صحيح",
    "origin": "من",
    "originalPassword": "كلمة المرور الأصلية",
    "password": "كلمة المرور",
    "phone": "رقم الهاتف",
    "pleChoose": "يرجى اختيار تاريخ الميلاد",
    "post": "الوظيفة",
    "postPlaceholder": "يرجى إدخال الوظيفة",
    "religion": "الدين",
    "religionPlaceholder": "يرجى اختيار الدين",
    "retrievePassword": "استعادة كلمة المرور",
    "setUp": "الإعدادات",
    "signOut": "تسجيل الخروج",
    "something": "أود أن أقول",
    "submit": "إرسال",
    "sureDelte": "هل أنت متأكد من رغبتك بالحذف؟",
    "teacher": "المحاضر",
    "learnYet": "لم تبدأ التعلم بعد",
    "uName": "اسم المستخدم",
    "uNamePlaceholder": "اسم المستخدم",
    "userCenter": "المعلومات الشخصية",
    "username": "اسم المستخدم",
    "validateMsg": "فشل التحقق",
    "woman": "أنثى",
    "learnTo": "مستوى التقدم",
    "myRecord": "سجلي",
    "plePhone": "يرجى إدخال رقم هاتف"
  },
  "notice_zlb": {
    "delete": "حذف",
    "home": "الصفحة الرئيسية",
    "lettre": "رسالة خاصة",
    "lettreEmpty": "لا يمكن أن تكون الرسالة الخاصة فارغة",
    "messageDetail": "تفاصيل الرسالة",
    "myMessage": "رسائلي",
    "notice": "ملاحظة",
    "nowBavarder": "الآن يمكنك بدء الدردشة",
    "send": "إرسال"
  },
  "play_zlb": {
    "networkTip": "إشعار الشبكة",
    "streamHighTip": "اتصال الشبكة الحالي مستقر. قمنا بالتغيير إلى الوضع عالي الوضوح.",
    "streamHighType": "عالي الوضوح",
    "streamNormTip": "اتصال الشبكة الحالي غير مستقر. قمنا بالتغيير إلى وضع الجودة العادية.",
    "streamNormType": "الجودة العادية",
    "liveTimeDes": "زمن البث المباشر",
    "livePlayWait": "لم يبدأ البث المباشر",
    "livePlayEnd": "انتهى البث المباشر"
  },
  "questionnaire_zlb": {
    "handed": "إرسال",
    "saveFailed": "فشل الحفظ",
    "examList": "قائمة أسئلة الاختبار"
  },
  "research_zlb": {
    "afternoon": "مساءً",
    "all": "الكل",
    "allCalendar": "كل جدول الأعمال",
    "alumniBook": "عضو",
    "broadcast": "× بدأ البث",
    "carriedout": "جاري",
    "certificate": "الشهادة",
    "comment": "التعليق",
    "comments": "كل × تعليق",
    "courses": "المراجع",
    "curDis": "جارية",
    "default": "لم يبدأ",
    "delete": "حذف",
    "detail": "التفاصيل",
    "discuss": "المنتدى",
    "end": "تم الانتهاء",
    "endAssess": "انتهى التقييم",
    "enterAssess": "بدء التقييم",
    "assessButton": "ملاحظات",
    "evaluation": "التقييم",
    "fileAcept": "نوع الملف خاطئ، يرجى التحميل مجددًا.",
    "fileSize10": "الملف المحدد يتجاوز 10ميجابايت، يرجى التحميل مجددًا.",
    "hisDis": "السجل",
    "lecture": "المراجع",
    "live": "مباشر",
    "livebroadcast": "البث المباشر",
    "minutes": "منذ × دقيقة",
    "month": "الشهر",
    "morning": "صباحًا",
    "noDiscussion": "لا توجد ورشة عمل",
    "noSchedule": "لا يوجد جدول أعمال",
    "notice": "ملاحظة",
    "notification": "ملاحظة غير مقروءة",
    "offline": "محاضرة وجهًا لوجه",
    "onging": "جارية",
    "online": "متصل",
    "operation": "واجب",
    "over": "تم الانتهاء",
    "participated": "مشارك بالفعل",
    "notParticipate": "لم تتم المشاركة بعد",
    "failedCourse": "لم ينجح",
    "passedCourse": "نجح",
    "preparation": "تحضير المهمة",
    "preparations": "تحضير المهمة",
    "preschoolLecture": "محاضرة تعريفية",
    "questionnaire": "الاستبيان",
    "questionType ": "اختيار من متعدد (إجابة واحدة فقط صحيحة؛ حدد كل الإجابات الصحيحة)",
    "readySay": "أود أن أقول",
    "replies": "لديك × ردود جديدة",
    "save": "حفظ",
    "schedule": "جدول الأعمال",
    "searchC": "البحث عن المواضيع التي تهتم بها",
    "seeAssess": "عرض التقييم",
    "submit": "إرسال",
    "submitHomewor": "إلغاء",
    "task": "مهمة",
    "taskToday": "مهمة اليوم",
    "video": "فيديو",
    "week": "أسبوع",
    "yourcomment": "اكتب تعليق",
    "legend": "أسطورة",
    "sunday": "الأحد",
    "monday": "الاثنين",
    "tuesday": "الثلاثاء",
    "wednesday": "الأربعاء",
    "thursday": "الخميس",
    "friday": "الجمعة",
    "saturday": "السبت",
    "consult": "المواد المرجعية",
    "schedules": "المهام",
    "calendar": "التقويم",
    "waitAssesment": "الاستبيان المطلوب إرساله",
    "year": "عام",
    "day": "اليوم",
    "preview": "المعاينة",
    "resource": "تنزيل"
  },
  "retrieve_zlb": {
    "emailEmpty": "لا يمكن أن يكون عنوان البريد الإلكتروني فارغًا.",
    "emailVerif": "التحقق من البريد الإلكتروني"
  },
  "task_zlb": {
    "downF": "تنزيل المرفقات",
    "repeatUp": "إعادة التحميل",
    "ruY": "إذا تم تحميل مرفق واحد على الطبيق، سوف يتم النسخ عليه إذا قمت بتحميل مرفق آخر على جهاز الكمبيوتر.",
    "submitC": "يرجى إدخال ما تريده إرساله",
    "uploadF": "تحميل المرفقات"
  },
  "upload_zlb": {
    "clickHere": "انقر هنا",
    "limit": "صيغة الملف تدعم PNG، وJPG بحجم لا يتجاوز",
    "preview": "المعاينة بعد تحميل الصورة",
    "upload": "تحميل"
  },
  "index": {
    "setAsHomePage": "تعيين بمثابة الصفحة الرئيسية",
    "addCollection": "إضافة إلى المفضلات",
    "telephone": "الخط الساخن",
    "Help": "مركز المساعدة",
    "SystemMessage": "إشعار النظام",
    "message": "رسالة خاصة",
    "emptyMessage": "مسح",
    "checkAllMessage": "عرض الكل",
    "noMessage": "لا توجد بيانات",
    "fullScreen": "عرض بكامل الشاشة",
    "ExitSystem": "الخروج من النظام",
    "back": "العودة",
    "top": "أعلى الصفحة",
    "backToTop": "العودة إلى الأعلى",
    "homePage": "الصفحة الرئيسية",
    "favoriteTips": "بسبب قيود متصاح 360 / متصفح جوجل، يرجى الضغط على Ctrl + D للإضافة للمفضلات يدويًا!",
    "autoSetHomeTips": "متصفحك لا يدم إعداد الصفحة الرئيسية تلقائيًا، يرجى استخدام قائمة المتصفح للتعيين يدويًا!",
    "currentUser": "المستخدم الحالي",
    "userHead": "صورة الملف الشخصي",
    "accountPassword": "كلمة مرور الحساب",
    "change": "تحديث",
    "head": "صورة الملف الشخصي",
    "continueStudy": "الاستمرار",
    "startStudy": "ابدأ التعلّم"
  },
  "course": {
    "count": "عام",
    "item": "مقال",
    "up": "الصفحة السابقة",
    "next": "الصفحة التالية",
    "items": "لكل صفحة",
    "go": "الانتقال إلى",
    "page": "الصفحة",
    "man": "المستخدم",
    "score": "الدرجة",
    "courseYear": "عام",
    "courseTeachers": "المحاضر",
    "noDesc": "بدون تقديم",
    "teachersDesc": "الملف التعريفي للمدرس",
    "checkLog": "عرض التسجيلات",
    "startStudy": "ابدأ التعلّم",
    "JoinLearning": "الانضمام",
    "isEvaluate": "تم التقييم",
    "deleteNoteButton": "حذف",
    "closeButton": "إغلاق",
    "noteSource": "من"
  },
  "onlineclass": {
    "myScore": "درجتي",
    "comments": "تعليق",
    "iknow": "أعلم",
    "detail": "التفاصيل",
    "inforCertificate": "الشهادة",
    "wantTalk": "أريد التعليق",
    "inputTalkContent": "يرجى إدخال تعليق",
    "publish": "تحرير",
    "undo": "إلغاء",
    "reply": "الرد",
    "delete": "حذف",
    "Learned": "اكتمل",
    "isDelete": "هل أنت متأكد من رغبتك بالحذف؟",
    "submitTime": "زمن الإرسال",
    "to": "إلى",
    "download": "تنزيل"
  },
  "usercenter": {
    "htllo": "مرحبًا",
    "welcomeMessage": "يوم سعيد",
    "searchTips": "البحث عن دورة تعليمية تعجبك",
    "myCertificate": "شهاداتي",
    "startQuestionnaire": "ابدأ الإجابة",
    "empty": "لا شيء",
    "confirmDelete": "تأكيد الحذف",
    "confirmDeleteTips": "هل أنت متأكد من رغبتك بالحذف؟",
    "delete": "حذف",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "إنهاء التعلّم",
    "tips": "إرشادات",
    "playTips": "إرشادات: يرجى النقر على زر \"إنهاء التعلم\" في أعلى اليمين للخروج. إذا خرجت من التعلم بإغلاق المتصفح، قد لا يتم تسجيل زمن التعلم بشكل صحيح.",
    "notShowAgain": "لا تذكرني مجددًا",
    "gotIt": "أعلم",
    "chapter": "الفصل",
    "language": "اللغة",
    "chapterText1": "الرقم",
    "chapterText2": "الفصل",
    "note": "ملاحظات",
    "noteBlockTitle": "ملاحظات",
    "evaluate": "تقييم",
    "evaluateStar": "نجمة",
    "saveEvaluate": "إرسال",
    "notePlaceholder": "يرجى تسجيل ملاحظات",
    "closeTips": "لم يتم حفظ التغييرات التي أجريتها",
    "closeButton": "المغادرة",
    "autoStop": "إيقاف التشغيل تلقائيًا",
    "autoStopTips": "انتهت مهلة عدم نشاط المستخدم. يتوقف التشغيل تلقائيًا.",
    "confirmOut": "هل أنت متأكد من إيقاف التشغيل؟",
    "closeOrNot": "إغلاق النافذة الحالية",
    "noCoursePlay": "لا توجد مصادر قابلة للتشغيل في الدورة التعليمية الحالية",
    "attention": "يرجى الانتباه"
  },
  "assessment_zlb": {
    "score": "الدرجة",
    "evalSuccess": "تم التقييم بنجاح"
  },
  "undefined": {}
};